import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

export const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	border: 1px solid #cdcdcd;

	${(props) =>
		props.isFocused &&
		css`
			color: #ffef35;
			border-color: #ffef35;
		`}

	${(props) =>
		props.isErrored &&
		css`
			border-color: #c53030;
		`}

  	input {
		flex: 1;
		background: transparent;
		height: 50px;
		border: 0;
		padding: 10px;
	}

	svg {
		margin-right: 1rem;
	}
`;

export const Error = styled(Tooltip)`
	svg {
		margin: 10px;
	}
`;
